var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('div',{staticClass:"text-md-center"},[_c('h1',[_vm._v("500")]),_c('h2',{staticClass:"my-3 headline"},[_vm._v("Desculpe. Nosso servidor caiu :-(")]),_c('br'),_c('br'),_c('div',[_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.goHome}},[_vm._v("Voltar")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }